import type {
  IStoreRankMoreCoreRankPrimaryKey,
  IStoreRankMoreCoreRankUnifiedKey,
  IStoreRankMoreTableDimensionInfos,
} from '@/pages/intelligence/types/storeRank';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';

export const PRIMARY_KEY: IStoreRankMoreCoreRankPrimaryKey = 'app_id';
export const UNIFIED_KEY: IStoreRankMoreCoreRankUnifiedKey = 'unified_id';
export const GAME_KEY: IStoreRankMoreCoreRankUnifiedKey = 'game_id';

// PC、Console store rank榜单下钻页、三端游戏详情页store rank页签 的 rank排名类型
export const RANK_TYPES = ['rank_1_3', 'rank_4_10', 'rank_11_50', 'rank_51_200'];

// PC、Console store rank榜单下钻页、三端游戏详情页store rank页签 的 rank排名类型 name映射
export const RANK_TYPES_NAMES_MAPPING: {
  [key: string]: string;
} = {
  rank_1_3: '1-3',
  rank_4_10: '4-10',
  rank_11_50: '11-50',
  rank_51_200: '51-200',
};

// PC、Console store rank榜单下钻页
export const PC_CONSOLE_SECTIONAL_RANK_KEYS = ['1-3', '4-10', '11-50', '51-200'];

export const PC_CONSOLE_SECTIONAL_RANK_INFOS: {
  [key: string]: IStoreRankMoreTableDimensionInfos;
} = {
  '1-3': {
    rendererType: 'TableShowDataRenderer',
    platform: '',
    top: '',
    title: '1-3',
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  '4-10': {
    rendererType: 'TableShowDataRenderer',
    platform: '',
    top: '',
    title: '4-10',
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  '11-50': {
    rendererType: 'TableShowDataRenderer',
    platform: '',
    top: '',
    title: '11-50',
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  '51-200': {
    rendererType: 'TableShowDataRenderer',
    platform: '',
    top: '',
    title: '51-200',
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
};

// storerank-详情-combine-数据源商店-对应榜单
export const COMBINE_STORERANK_DETAIL_SOURCE_TOPCHARTS = {
  steam: [
    {
      textKey: 'dbi_store_rank_top_sellers',
      lable: 'dbi_store_rank_top_sellers',
      text: 'dbi_store_rank_top_sellers',
      icon: 'steam',
      value: 'steam top sellers',
    },
    {
      textKey: 'dbi_store_rank_most_played',
      value: 'daily steam top 100 players',
    },
    {
      textKey: 'dbi_store_rank_new_and_trending',
      value: 'steam new and trending',
    },
    {
      textKey: 'dbi_store_rank_top_wish_lists',
      value: 'steam top wish lists',
    },
  ],
  epic: [
    {
      textKey: 'dbi_store_rank_top_sellers',
      value: 'epic top sellers',
    },
    {
      textKey: 'dbi_store_rank_top_popular',
      value: 'epic top popular',
    },
  ],
  playstation: [
    {
      textKey: 'dbi_store_rank_playstation_best_selling',
      value: 'playstation best selling',
    },
    {
      textKey: 'dbi_store_rank_playstation_most_downloaded',
      value: 'playstation most downloaded',
    },
    {
      textKey: 'dbi_store_rank_playstation_new_games',
      value: 'playstation new games',
    },
    {
      textKey: 'dbi_store_rank_playstation_coming_soon',
      value: 'playstation coming soon',
    },
    {
      textKey: 'dbi_store_rank_playstation_indies_games',
      value: 'playstation indies games',
    },
    {
      textKey: 'dbi_store_rank_playstation_free_to_play',
      value: 'playstation free to play',
    },
  ],
} as any;

// storerank-详情-combine-数据源商店list
export const COMBINE_STORERANK_DETAIL_SOURCE_LIST: string[] = [
  'steam',
  'epic',
  'playstation',
  'xbox',
  'nintendo',
];

// storerank-详情-combine-指标配置
export const STORERANK_METRICS_OPTIONS_LIST: any[] = [
  {
    value: 'steam top sellers',
    textKey: 'dbi_store_rank_top_sellers',
    svg: 'steam',
    dataSource: 'steam',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Top Sellers(Steam)',
  },
  {
    value: 'daily steam top 100 players',
    textKey: 'dbi_store_rank_most_played',
    svg: 'steam',
    dataSource: 'steam',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Most Played(Steam)',
  },
  {
    value: 'steam new and trending',
    textKey: 'dbi_store_rank_new_and_trending',
    svg: 'steam',
    dataSource: 'steam',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'New and Trending(Steam)',
  },
  {
    value: 'steam top wish lists',
    textKey: 'dbi_store_rank_top_wish_lists',
    svg: 'steam',
    dataSource: 'steam',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Top Wish Lists(Steam)',
  },
  {
    value: 'epic top sellers',
    textKey: 'dbi_store_rank_top_sellers',
    svg: 'epic',
    dataSource: 'epic',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Top Sellers(Epic)',
  },
  {
    value: 'epic top popular',
    textKey: 'dbi_store_rank_top_popular',
    svg: 'epic',
    dataSource: 'epic',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Top Popular(Epic)',
  },
  {
    value: 'playstation best selling',
    textKey: 'dbi_store_rank_best_selling',
    svg: 'playstation',
    dataSource: 'playstation',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Best Selling(Playstation)',
  },
  {
    value: 'playstation most downloaded',
    textKey: 'dbi_store_rank_most_downloaded',
    svg: 'playstation',
    dataSource: 'playstation',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Most Downloaded(Playstation)',
  },
  {
    value: 'playstation new games',
    textKey: 'dbi_store_rank_new_games',
    svg: 'playstation',
    dataSource: 'playstation',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'New Games(Playstation)',
  },
  {
    value: 'playstation coming soon',
    textKey: 'dbi_store_rank_coming_soon',
    svg: 'playstation',
    dataSource: 'playstation',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Coming Soon(Playstation)',
  },
  {
    value: 'playstation indies games',
    textKey: 'dbi_store_rank_indies_games',
    svg: 'playstation',
    dataSource: 'playstation',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Indies Games(Playstation)',
  },
  {
    value: 'playstation free to play',
    textKey: 'dbi_store_rank_free_to_play',
    svg: 'playstation',
    dataSource: 'playstation',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Free to Play(Playstation)',
  },
  // {
  //   value: 'ps5 most downloaded',
  //   textKey: 'dbi_store_rank_ps5_most_downloaded',
  //   svg: 'playstation',
  //   dataSource: 'playstation',
  //   renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
  //   downloadTitle: 'Most Downloaded(PS5)',
  // },
  // {
  //   value: 'ps4 most downloaded',
  //   textKey: 'dbi_store_rank_ps4_most_downloaded',
  //   svg: 'playstation',
  //   dataSource: 'playstation',
  //   renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
  //   downloadTitle: 'Most Downloaded(PS4)',
  // },
  // {
  //   value: 'ps vr most downloaded',
  //   textKey: 'dbi_store_rank_vr_games',
  //   svg: 'playstation',
  //   dataSource: 'playstation',
  //   renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
  //   downloadTitle: 'Most Downloaded(PS VR)',
  // },
  {
    value: 'xbox new release',
    textKey: 'dbi_store_rank_new_release',
    svg: 'xbox',
    dataSource: 'xbox',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'New Release(Xbox)',
  },
  {
    value: 'xbox upcoming',
    textKey: 'dbi_store_rank_upcoming',
    svg: 'xbox',
    dataSource: 'xbox',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Upcoming(Xbox)',
  },
  {
    value: 'xbox most played',
    textKey: 'dbi_store_rank_most_played',
    svg: 'xbox',
    dataSource: 'xbox',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Most Played(Xbox)',
  },
  {
    value: 'xbox best rated',
    textKey: 'dbi_store_rank_best_rated',
    svg: 'xbox',
    dataSource: 'xbox',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Best Rated(Xbox)',
  },
  {
    value: 'xbox top free',
    textKey: 'dbi_store_rank_top_free',
    svg: 'xbox',
    dataSource: 'xbox',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Top Free(Xbox)',
  },
  {
    value: 'xbox top paid',
    textKey: 'dbi_store_rank_top_paid',
    svg: 'xbox',
    dataSource: 'xbox',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Top Paid(Xbox)',
  },
  {
    value: 'nintendo best sellers',
    textKey: 'dbi_store_rank_best_selling',
    svg: 'nintendo',
    dataSource: 'nintendo',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Best Sellers(Nintendo)',
  },
  {
    value: 'nintendo new release',
    textKey: 'dbi_store_rank_new_release',
    svg: 'nintendo',
    dataSource: 'nintendo',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'New Release(Nintendo)',
  },
  {
    value: 'nintendo coming soon',
    textKey: 'dbi_store_rank_coming_soon',
    svg: 'nintendo',
    dataSource: 'nintendo',
    renderType: RenderType.RANK_AND_RATIO_STORERANK_DETAIL,
    downloadTitle: 'Coming Soon(Nintendo)',
  },
];
